import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for pause ad information overlay.
 * Provides a gradient background overlay for pause ad content.
 */
const PauseAdInfoContainer = styled.div`
  background: #000000;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  position: fixed;
  top: 0;
  left: 0;
  width: ${780 * Screen.widthRatio}px;
  height: ${1080 * Screen.widthRatio}px;
`;

export default PauseAdInfoContainer;
